import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@awesome.me/kit-5231b03bd6/icons/classic/regular';
import { components, ControlProps } from 'react-select';
import { ComboBoxPrediction, IsMulti } from '~/utilities';

export const Control = (props: ControlProps<ComboBoxPrediction, IsMulti>) => (
  <components.Control {...props}>
    <FontAwesomeIcon
      icon={faMagnifyingGlass}
      className="pl-2 text-neutral-60"
    />
    {props.children}
  </components.Control>
);
